<template>
  <div class="style-settings">
    <point-style
      :id="id"
      :layer-style="layerStyle"
      :layer-controller="layerController"
      @change-property="changeProperty"
      @change-classes="changeClasses"
      @change-strings="changeStrings"
      @change-range="changeRange"
      v-if="geomType === 'point' || geomType === 'multi_point'"
    />
    <line-style
      :id="id"
      :layer-style="layerStyle"
      :layer-controller="layerController"
      @change-property="changeProperty"
      @change-classes="changeClasses"
      @change-strings="changeStrings"
      @change-range="changeRange"
      @toggle-line-property="toggleLineProperty"
      v-else-if="geomType === 'line_string' || geomType === 'multi_line_string'"
    />
    <polygon-style
      :id="id"
      :layer-style="layerStyle"
      :layer-controller="layerController"
      :style-controller="styleController"
      @change-property="changeProperty"
      @change-classes="changeClasses"
      @change-strings="changeStrings"
      @change-range="changeRange"
      v-else-if="geomType === 'polygon' || geomType === 'multi_polygon'"
    />
  </div>
</template>

<script>
import PointStyle from "./point-style";
import LineStyle from "./line-style";
import PolygonStyle from "./polygon-style";

export default {
  props: [
    "id",
    "layer-style",
    "geom-type",
    "layer-controller",
    "style-controller"
  ],
  components: {
    PointStyle,
    LineStyle,
    PolygonStyle
  },
  methods: {
    changeProperty({ type, field }) {
      this.styleController.changeProperty(this.id, type, field);
    },
    changeClasses({ field }) {
      this.styleController.changeColorClasses(this.id, field);
    },
    changeStrings({ field }) {
      this.styleController.changeColorStrings(this.id, field);
    },
    changeRange({ field }) {
      this.styleController.changeRange(this.id, field);
    },
    toggleLineProperty(type) {
      switch (type) {
        case "dashed":
          return this.styleController.toggleLineProperty(this.id, type);
        case "arrows":
          return this.layerController.toggleArrows(this.id);
      }
    }
  }
};
</script>

<style lang="scss">
.map-style {
  &__block {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
}
</style>
